<fgb-banner [memberName]="memberName" [pageTitle]="pageTitle"></fgb-banner>

<fgb-page-header [pageTitle]="'account.page.title'" [backButtonLink]="backButtonLink" />

<fgb-account-nav></fgb-account-nav>

<ng-content></ng-content>
